<cmps-wait-status *ngIf="state?.pending?.config"></cmps-wait-status>

<ng-container
    *ngIf="!state?.pending?.config && state?.configs[state?.activeConfig]"
>
    <div cmpsInsightSelectionCollapse>
        <div class="insight-group-1">
            <div
                rvirus
                cmpsInsightPersist
                [isDefault]="context.isDefault"
                [isFavourite]="context.isFavourite"
                [disallowSetDefault]="
                    state?.configs[state?.activeConfig]?.disallowSetDefault
                "
                [disallowSetFavourite]="
                    state?.configs[state?.activeConfig]?.disallowSetFavourite
                "
                (defaultClick)="setDefault.emit($event)"
                (favouriteClick)="setFavourite.emit($event)"
            ></div>

            <div data-insight-snce-summary>
                <div
                    rvirus
                    cmpsInsightSelectionSummary
                    [periodType]="state?.period?.periodType"
                    [cacheDates]="cacheDates"
                    [eventDate]="state?.period?.eventDate"
                    [quickSwitch]="state?.levelOpt?.quickSwitch"
                    [quickSwitchItem]="state?.levelOpt?.active"
                    [quickSwitchLabel]="optsLabel?.label"
                ></div>

                <!--TODO tl-->
                <button
                    class="btn bg-transparent cmps-cdk-py-0dot5"
                    data-insight-snce-toggle="show"
                    ngbTooltip="Change selection"
                    placement="top"
                >
                    <cmps-icon svgIcon="pencil-outline"></cmps-icon>
                </button>
            </div>
        </div>

        <div class="insight-group-2">
            <div data-insight-snce-full>
                <div>
                    <div
                        [class.mb-3]="
                            state?.levelOpt?.filteredItems?.length !== 0 &&
                            state?.levelOpt?.canChangeActive
                        "
                        cmpsInsightPeriod
                        [allowedPeriodTypes]="
                            state?.configs[state?.activeConfig]?.periods
                        "
                        [periodType]="state?.period?.periodType"
                        (periodTypeChange)="onPeriodTypeChange($event)"
                        [cacheDates]="cacheDates"
                        [eventDate]="state?.period?.eventDate"
                        (eventDateChange)="onEventDateChange($event)"
                    ></div>

                    <ng-container
                        *ngIf="
                            !state?.pending?.configReload &&
                            !state?.period?.pending?.periodType &&
                            !state?.levelOpt?.pending &&
                            state?.period?.eventDate &&
                            state?.levelOpt?.active
                        "
                    >
                        <div
                            cmpsPerformanceInsightLevelOption
                            [quickSwitch]="state?.levelOpt?.quickSwitch"
                            [filteredItems]="state?.levelOpt?.filteredItems"
                            [selected]="state?.levelOpt?.active"
                            (selectionChange)="
                                onLevelOptionSelectionChange($event)
                            "
                            [canChangeActive]="state?.levelOpt?.canChangeActive"
                            (optsLabelChange)="optsLabel = $event"
                        ></div>
                    </ng-container>
                </div>

                <!--TODO tl-->
                <button
                    class="btn bg-transparent cmps-cdk-py-0dot5"
                    data-insight-snce-toggle="hide"
                    ngbTooltip="Collapse selection"
                    placement="top"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>
            </div>
        </div>
    </div>

    <cmps-wait-status
        *ngIf="
            state?.pending?.configReload ||
            state?.period?.pending?.periodType ||
            state?.levelOpt?.pending
        "
    ></cmps-wait-status>

    <ng-container
        *ngIf="
            !state?.pending?.configReload &&
            !state?.period?.pending?.periodType &&
            !state?.levelOpt?.pending &&
            state?.period?.eventDate &&
            state?.levelOpt?.active
        "
    >
        <div
            rvirus
            cmpsInsightLegend
            class="insight-legend-pos"
            [metricThresholds]="state?.legend?.metricThresholds"
            [trends]="state?.legend?.trendsArrows"
            [showThresholdColours]="state?.activeView?.showThresholdColours"
            [showTrendArrows]="state?.activeView?.showTrendArrows"
            *ngIf="state?.activeView"
        ></div>

        <div class="insight-item">
            <span
                *ngIf="
                    state?.levelOpt?.quickSwitch?.quickSwitchType ===
                    QuickSwitchType.MARKET
                "
            >
                {{ i18n._832_MARKET | translate }}
            </span>
            <span
                *ngIf="
                    state?.levelOpt?.quickSwitch?.quickSwitchType !==
                    QuickSwitchType.MARKET
                "
            >
                {{ state?.levelOpt?.active?.name }}
            </span>
        </div>
    </ng-container>

    <div
        class="text-center"
        *ngIf="
            !state?.pending?.configReload &&
            !state?.period?.pending?.periodType &&
            !state?.levelOpt?.pending &&
            (!state?.period?.eventDate ||
                !state?.levelOpt?.active ||
                !state?.activeView)
        "
    >
        {{ i18n._711_NO_DATA_AVAILABLE | translate }}
    </div>

    <div
        [class]="'insight-underlay ' + _sheet.classes.underlay"
        [ngClass]="{
            'is-overlaid': state?.activeViewPillar && state?.activeViewMetric
        }"
        *ngIf="
            !state?.pending?.configReload &&
            !state?.period?.pending?.periodType &&
            !state?.levelOpt?.pending &&
            state?.period?.eventDate &&
            state?.levelOpt?.active &&
            state?.activeView
        "
    >
        <div
            cmpsPerformanceInsightVisual
            [view]="state?.activeView"
            [metrics]="state?.configs[state?.activeConfig]?.metrics"
            [periodType]="state?.period?.periodType"
            [eventDate]="state?.period?.eventDate"
            [levelOpt]="state?.levelOpt?.active"
            [quickSwitch]="state?.levelOpt?.quickSwitch"
            [initialCriteriaIdType]="
                state?.configs[state?.activeConfig]?.initialCriteriaIdType
            "
            [initialDataFilterOpts]="state?.initialDataFilterOpts"
            [optionalColumns]="state?.optionalColumns"
            (itemClick)="onVisualItemClick($event)"
        ></div>

        <div
            class="insight-overlay"
            [ngClass]="_sheet.classes.overlay"
            *ngIf="state?.activeViewPillar && state?.activeViewMetric"
        >
            <div class="insight-overlay-content">
                <button
                    class="btn bg-transparent insight-overlay-close"
                    tabindex="-1"
                    (click)="onCloseOverlay()"
                >
                    <cmps-icon svgIcon="close"></cmps-icon>
                </button>

                <div class="insight-overlay-head">
                    <div class="d-flex align-items-center">
                        <div
                            rvirus
                            cmpsInsightSelectedVisualItem
                            [pillarName]="state?.activeViewPillar?.name"
                            [metricName]="state?.activeMetric?.shortName"
                            [dataMetric]="state?.activeDataMetric"
                            [showThresholdColours]="
                                state?.activeView?.showThresholdColours
                            "
                            [showTrendArrows]="
                                state?.activeView?.showTrendArrows
                            "
                        ></div>

                        <!--maybe overkill as its own comp, but intended-->
                        <div
                            cmpsInsightPresentation
                            [selection]="state?.presentAs"
                            (selectionChange)="
                                onPresentationSelectionChange($event)
                            "
                        ></div>
                    </div>

                    <div
                        cmpsInsightPath
                        [paths]="state?.configs[state?.activeConfig]?.paths"
                        [path]="state?.activePath"
                        (pathChange)="onPathChange($event)"
                    ></div>

                    <div class="d-flex align-items-center">
                        <div
                            rvirus
                            cmpsInsightCustomize
                            [pillars]="
                                state?.presentAs === PresentationView.GRID
                            "
                            [pillarsPillars]="state?.activeView?.pillars"
                            [pillarsSelection]="state?.activePillars"
                            (pillarsSelectionChange)="
                                onPillarsSelectionChange($event)
                            "
                            [pillarsCanSelect]="canSelectPillar"
                            [columns]="true"
                            [columnsColumns]="
                                state?.presentAs === PresentationView.GRID
                                    ? state?.grid?.supportedColumns
                                    : state?.trend?.supportedColumns
                            "
                            [columnsSelection]="
                                state?.presentAs === PresentationView.GRID
                                    ? state?.grid?.activeColumns
                                    : state?.trend?.activeColumns
                            "
                            (columnsSelectionChange)="
                                onColumnsSelectionChange($event)
                            "
                            [metrics]="
                                state?.presentAs === PresentationView.TREND
                            "
                            [metricsMetrics]="
                                state?.configs[state?.activeConfig]?.metrics
                            "
                            [metricsPillars]="state?.activeView?.pillars"
                            [metricsSelection]="state?.activeMetrics"
                            (metricsSelectionChange)="
                                onMetricsSelectionChange($event)
                            "
                            *ngIf="!state?.pending?.supportedColumns"
                        ></div>

                        <div
                            class="ml-5 insight-export"
                            *ngIf="state?.presentAs === PresentationView.GRID"
                        >
                            <button
                                class="btn bg-transparent pr-0 pl-0"
                                (click)="onExportGridClick()"
                            >
                                <cmps-icon
                                    class="legacy:cmps-cdk-fill-green-100 cmps-cdk-mr-0dot5"
                                    svgIcon="download"
                                ></cmps-icon>
                                <span>Export Data</span>
                            </button>
                        </div>
                    </div>

                    <div
                        class="insight-presentation-trend"
                        *ngIf="state?.presentAs === PresentationView.TREND"
                    >
                        <div>
                            <button
                                type="button"
                                class="btn bg-transparent pr-0 pl-0"
                                data-toggle-trend-users
                                (click)="onToggleTrendFirstGridColumn()"
                            >
                                <cmps-icon
                                    class="legacy:cmps-cdk-fill-green-100"
                                    [svgIcon]="
                                        !state?.trendHideFirstGridColumn
                                            ? 'chevron-left-circle'
                                            : 'chevron-right-circle'
                                    "
                                ></cmps-icon>
                                <span>{{
                                    (!state?.trendHideFirstGridColumn
                                        ? 'Hide'
                                        : 'Show'
                                    ) | translate
                                }}</span>
                            </button>
                        </div>

                        <div
                            cmpsInsightPeriod
                            class="text-right"
                            [allowedPeriodTypes]="state?.trend?.periods"
                            [periodType]="state?.trend?.periodType"
                            (periodTypeChange)="onTrendPeriodTypeChange($event)"
                        ></div>
                    </div>
                </div>

                <div
                    class="insight-overlay-body"
                    *ngIf="!state?.pending?.supportedColumns"
                >
                    <div
                        rvirus
                        cmpsPerformanceInsightGrid
                        [config]="context.config"
                        [view]="state?.activeView"
                        [metrics]="state?.configs[state?.activeConfig]?.metrics"
                        [periodType]="state?.period?.periodType"
                        [cacheDates]="cacheDates"
                        [eventDate]="state?.period?.eventDate"
                        [initialDataFilterOpts]="state?.initialDataFilterOpts"
                        [viewPillar]="state?.activeViewPillar"
                        [viewMetric]="state?.activeViewMetric"
                        [path]="state?.activePath"
                        [roleHierarchy]="state?.roleHierarchy"
                        [pillars]="state?.activeView?.pillars"
                        [pillarSelection]="state?.activePillars"
                        [columns]="state?.grid?.supportedColumns"
                        [columnSelection]="state?.grid?.activeColumns"
                        [maxSelection]="20"
                        [configUserInfo]="state?.configUserInfo"
                        [className]="_sheet.classes.overlayBody"
                        [maxHeight]="overlayBodyHeight"
                        [trendVisible]="
                            state?.presentAs === PresentationView.TREND
                        "
                        [trendHideFirstGridColumn]="
                            state?.trendHideFirstGridColumn
                        "
                        (layout)="gridClassName = $event"
                        (newTabClick)="onGridNewTabClick($event)"
                        (selectionChange)="onGridSelectionChange($event)"
                    ></div>

                    <div
                        cmpsPerformanceInsightTrend
                        [metrics]="state?.configs[state?.activeConfig]?.metrics"
                        [eventDate]="state?.period?.eventDate"
                        [initialDataFilterOpts]="state?.initialDataFilterOpts"
                        [columnSelection]="state?.trend?.activeColumns"
                        [gridSelection]="gridSelection"
                        [metricSelection]="state?.activeMetrics"
                        [className]="_sheet.classes.overlayBody"
                        [gridClassName]="gridClassName"
                        *ngIf="state?.presentAs === PresentationView.TREND"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-template
    #atLeastOnePillarDialogTpl
    let-dismiss="dismiss"
>
    <div class="modal-header">
        <button
            type="button"
            class="close"
            [attr.aria-label]="'Close' | translate"
            (click)="dismiss()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <span>{{ 'Select at least one pillar.' | translate }}</span>
    </div>
    <div class="modal-footer">
        <button
            type="button"
            class="btn btn-primary"
            (click)="dismiss()"
        >
            {{ 'Close' | translate }}
        </button>
    </div>
</ng-template>
